import Box, { BoxProps } from '@mui/material/Box';

export const FlexColumn = ({ children, ...props }: BoxProps) => {
  return (
    <Box display='flex' flexDirection='column' {...props}>
      {children}
    </Box>
  );
};
